import {Expressions, Types, type Type} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import type {TranslatedNodeData} from '@packages/systems/localization-types';
import {reservedImageAltValues} from './constants';

export function getTranslatableAltOverrides(
  componentInstance: ExpressionElement,
  componentProperties: {[key: string]: Type}
): TranslatedNodeData[] {
  const componentPropertiesIds = Object.keys(componentProperties);
  return componentPropertiesIds.reduce<TranslatedNodeData[]>(
    (overridesToTranslate, componentPropertyId) => {
      const propertyType = componentProperties[componentPropertyId];

      if (propertyType && Types.isAltTextType(propertyType)) {
        const overrideValue = Expressions.getIn(
          Expressions.getElementData(componentInstance),
          [{in: 'Record', at: componentPropertyId}]
        );

        if (!overrideValue) return overridesToTranslate;

        const value = Expressions.getText(overrideValue);

        if (value && !reservedImageAltValues.includes(value)) {
          const componentInstanceId =
            Expressions.getElementId(componentInstance);
          overridesToTranslate.push({
            _id: componentInstanceId,
            type: 'attr-property-override',
            text: true,
            v: value,
            fieldId: componentPropertyId,
            translatableParentId: componentInstanceId,
          });
        }
      }

      return overridesToTranslate;
    },
    []
  );
}
